<template>
  <div class="sqjl-box">
    <div class="sqjl-top">
      <div class="sqjl-tabs">
        <div 
          :class="tabIndex === index ? 'sqjl-tab-active' : 'sqjl-tab'" 
          v-for="(item, index) in tabs" 
          :key="index" 
          @click="handleTabChange(index)"
        >
          {{item}}
        </div>
      </div>
    </div>
    <div class="sqjl-table">
      <div class="sqjl-table-header">
        <span class="sqjl-table-col sqjl-col">{{$t('all.shenqingriqi')}}</span>
        <span class="sqjl-table-col sqjl-col">{{$t('all.zhiboshijianduan')}}</span>
        <span class="sqjl-table-col sqjl-col">{{$t('all.zhiboleixing')}}</span>
        <span class="sqjl-table-col sqjl-col">{{$t('all.daihuo')}}</span>
        <span class="sqjl-table-col sqjl-col">UNImall【{{$t('all.zhanghaoid')}}】</span>
        <span class="sqjl-table-col sqjl-col">{{$t('all.beizhu')}}</span>
        <span class="sqjl-table-col sqjl-col">{{$t('all.zhuangtai')}}</span>
      </div>
      <div class="sqjl-table-body" v-if="filteredList.length > 0" ref="tableBody">
        <div class="sqjl-table-row" v-for="(item, index) in filteredList" :key="item.id || index">
          <span class="sqjl-table-col sqjl-col">{{item.applyDate || item.liveDate || ''}}</span>
          <span class="sqjl-table-col sqjl-col">{{item.timeSlot || item.liveTime || ''}}</span>
          <span class="sqjl-table-col sqjl-col">{{item.liveType === 1 ? $t('all.shoujizhibo') : 'OBS' + $t('all.zhibo')}}</span>
          <span class="sqjl-table-col sqjl-col" :class="item.isGoods === 1 ? '' : 'sqjl-text-red'">{{item.isGoods === 1 ? $t('all.kaiqi') : $t('all.guanbi')}}</span>
          <span class="sqjl-table-col sqjl-col">{{item.businessAccount || item.accountId || '/'}}</span>
          <span class="sqjl-table-col sqjl-col">{{item.submitMsg}}</span>
          <span class="sqjl-table-col sqjl-col">
            <div class="sqjl-status-wrap">
              <span :class="getStatusClass(item.status)">{{getStatusText(item.status)}}</span>
              <span class="sqjl-detail" @click="handleDetail(item)">{{$t('all.xiangqing')}}</span>
              <span class="sqjl-reason" v-if="item.status === 2 && item.rejectionMsg">{{$t('all.yuanyin')}}：{{item.rejectionMsg}}</span>
            </div>
          </span>
        </div>
      </div>
      <div class="sqjl-table-empty" v-if="!isLoading && loaded && filteredList.length === 0">
        {{$t('all.zanwushuju')}}
      </div>
    </div>
	
	<!-- 申请详情弹框 -->
	<div class="sqxq-overlay" v-if="showDetail" @click="showDetail = false"></div>
	<div class="sqxq-modal" v-if="showDetail" @click.stop>
		<div class="sqxq-title">{{$t('all.shenqingxiangqing')}}</div>
		<!-- 基本信息卡片 -->
		<div class="sqxq-info-card">
			<div class="sqxq-info-card-left">
				<span class="sqxq-info-card-date">{{detailData.liveDate}} {{detailData.liveTime}}</span>
				<span class="sqxq-info-card-desc" v-if="detailData.status !== 2">
				  {{detailData.liveType === 1 ? $t('all.shoujizhibo') : 'OBS' + $t('all.zhibo')}}
				  <span v-if="detailData.businessAccount">| {{$t('all.daihuo')}}：{{detailData.businessAccount}}</span>
				</span>
				<span class="sqxq-info-card-desc" v-if="detailData.status === 2">{{$t('all.yuanyin')}}：{{detailData.rejectionMsg}}</span>
			</div>
			<span :class="getDetailStatusClass(detailData.status)">{{getStatusText(detailData.status)}}</span>
		</div>
		<!-- 审核原因（未通过时显示） -->
		<div class="sqxq-reason-card" v-if="detailData.status === 2">
			<div class="sqxq-reason-card-header">
				<span class="sqxq-reason-card-title">{{$t('all.shenheyuanyin')}}</span>
				<span class="sqxq-reason-tag">{{$t('all.xutiaozheng')}}</span>
			</div>
			<span class="sqxq-reason-text">{{detailData.rejectionMsg}}</span>
		</div>
		<!-- 流程步骤（待审核/已通过时显示） -->
		<div class="sqxq-steps" v-if="detailData.status !== 2">
			<div class="sqxq-step" v-for="(step, idx) in detailSteps" :key="idx">
				<div class="sqxq-step-left">
					<div :class="getStepDotClass(step)">{{idx + 1}}</div>
					<div class="sqxq-step-line" v-if="idx < detailSteps.length - 1"></div>
				</div>
				<span class="sqxq-step-name">{{step.name}}</span>
				<span :class="step.done ? 'sqxq-step-status-done' : (step.current ? 'sqxq-step-status-current' : 'sqxq-step-status')">{{step.statusText}}</span>
			</div>
		</div>
		<!-- 已通过流程步骤（未通过时显示简化版） -->
		<div class="sqxq-steps" v-if="detailData.status === 2">
			<div class="sqxq-step">
				<div class="sqxq-step-left">
					<div class="sqxq-step-dot-done">1</div>
					<div class="sqxq-step-line"></div>
				</div>
				<span class="sqxq-step-name">{{$t('all.tijiaoshenqing')}}</span>
				<span class="sqxq-step-status-done">{{$t('all.wancheng')}}</span>
			</div>
			<div class="sqxq-step">
				<div class="sqxq-step-left">
					<div class="sqxq-step-dot-done">2</div>
				</div>
				<span class="sqxq-step-name">{{$t('all.houtaishenhe')}}</span>
				<span class="sqxq-step-status-reject">{{$t('all.weitongguo')}}</span>
			</div>
		</div>
		<!-- 备注卡片（待审核/已通过时显示） -->
		<div class="sqxq-remark-card" v-if="detailData.status !== 2">
			<div class="sqxq-remark-card-header">
				<span class="sqxq-remark-card-title">{{$t('all.beizhu')}}</span>
				<span class="sqxq-remark-tag">{{$t('all.kechakan')}}</span>
			</div>
			<span class="sqxq-remark-text">{{$t('all.huodongzhuti')}}：{{detailData.submitMsg || detailData.remark || $t('all.jinwanxinpinfuli')}}</span>
		</div>
		<!-- 底部按钮 -->
		<div class="sqxq-btn" v-if="detailData.status === 0" @click="handleRevoke">{{$t('all.chehuishenqing')}}</div>
		<div class="sqxq-btn sqxq-btn-gradient" v-if="detailData.status === 1 && detailData.keyReady" @click="handleGoKey">{{$t('all.zhibojinyao')}}</div>
		<div class="sqxq-btn sqxq-btn-gradient" v-if="detailData.status === 2" @click="handleReapply">{{$t('all.chongxinshenqing')}}</div>
	</div>
  </div>
</template>

<script>
import { getUserLiveApplyRecordList, getLiveApplyInfo, returnLiveApply } from "@/api/zhiboshenqing";
export default {
  data() {
    return {
      tabIndex: 0,
      tabs: [],
      list: [],
      showDetail: false,
      detailData: {},
      isLoading: false,
      loaded: false,
      hasMore: true,
      queryParams: {
        page: 1,
        size: 20,
        status: ''
      }
    };
  },
  computed: {
    filteredList() {
      if (this.tabIndex === 0) return this.list;
      return this.list.filter(item => item.status === this.tabIndex);
    },
    detailSteps() {
      const isApproved = this.detailData.status === 1;
      const keyReady = this.detailData.keyReady;
      const steps = [
        { name: this.$t('all.tijiaoshenqing'), done: true, current: false, statusText: this.$t('all.wancheng') },
        { name: this.$t('all.houtaishenhe'), done: isApproved, current: !isApproved, statusText: isApproved ? this.$t('all.wancheng') : this.$t('all.chulizhong') },
        { name: this.$t('all.chanshengmiyao'), done: keyReady, current: isApproved && !keyReady, statusText: keyReady ? this.$t('all.wancheng') : this.$t('all.daichuli') },
        { name: this.$t('all.youjiankuaidi'), done: keyReady, current: false, statusText: keyReady ? this.$t('all.wancheng') : this.$t('all.daichuli') }
      ];
      return steps;
    }
  },
  mounted() {
    this.tabs = [
      this.$t('all.quanbu'),
      this.$t('all.daishenhe'),
      this.$t('all.yitongguo'),
      this.$t('all.weitongguo')
    ];
    this.loadData();
  },
  updated() {
    this.$nextTick(() => {
      if (this.$refs.tableBody) {
        this.$refs.tableBody.removeEventListener('scroll', this.handleScroll);
        this.$refs.tableBody.addEventListener('scroll', this.handleScroll);
      }
    });
  },
  beforeDestroy() {
    if (this.$refs.tableBody) {
      this.$refs.tableBody.removeEventListener('scroll', this.handleScroll);
    }
  },
  methods: {
    handleTabChange(index) {
      this.tabIndex = index;
      this.queryParams.status = index === 0 ? '' : index - 1;
      this.queryParams.page = 1;
      this.hasMore = true;
      this.list = [];
      this.loadData();
    },
    async loadData() {
      if (this.isLoading || !this.hasMore) return;
      this.isLoading = true;
      try {
        const response = await getUserLiveApplyRecordList(this.queryParams);
        const data = response.data || response;
        const newList = Array.isArray(data) ? data : (data.rows || data.list || []);
        if (this.queryParams.page === 1) {
          this.list = newList;
        } else {
          this.list = [...this.list, ...newList];
        }
        const total = data.total || newList.length;
        const totalPages = Math.ceil(total / this.queryParams.size);
        this.hasMore = this.queryParams.page < totalPages;
      } catch (error) {
        console.error("获取申请记录失败:", error);
      } finally {
        this.isLoading = false;
        this.loaded = true;
      }
    },
    handleScroll(e) {
      if (this.isLoading || !this.hasMore) return;
      const target = e.target || this.$refs.tableBody;
      if (!target) return;
      const scrollTop = target.scrollTop;
      const clientHeight = target.clientHeight;
      const scrollHeight = target.scrollHeight;
      if (scrollTop + clientHeight >= scrollHeight - 50) {
        this.queryParams.page++;
        this.loadData();
      }
    },
    getStatusText(status) {
      if (status === 0) return this.$t('all.daishenhe');
      if (status === 1) return this.$t('all.yitongguo');
      if (status === 2) return this.$t('all.weitongguo');
      return '';
    },
    getStatusClass(status) {
      if (status === 0) return 'sqjl-status-pending';
      if (status === 1) return 'sqjl-status-pass';
      if (status === 2) return 'sqjl-status-reject';
      return '';
    },
    getDetailStatusClass(status) {
      if (status === 0) return 'sqxq-status-pending';
      if (status === 1) return 'sqxq-status-pass';
      if (status === 2) return 'sqxq-status-reject';
      return '';
    },
    getStepDotClass(step) {
      if (step.done) return 'sqxq-step-dot-done';
      if (step.current) return 'sqxq-step-dot-current';
      return 'sqxq-step-dot';
    },
    async handleDetail(item) {
	  const res = await getLiveApplyInfo({applyId:item.applyId})
	  if(res.data.status == 1){
		this.$router.push({ path: '/zhibojinyao',query: {
		  applyId: item.applyId
		}});
	  }else{
		this.detailData = res.data;
		this.showDetail = true;  
	  }
    },
    async handleRevoke() {
      try {
        await returnLiveApply({ applyId: this.detailData.applyId });
        this.$message.success(this.$t('all.caozuochenggong'));
        this.showDetail = false;
        this.queryParams.page = 1;
        this.hasMore = true;
        this.list = [];
        this.loadData();
      } catch (error) {
        console.error("撤回申请失败:", error);
      }
    },
    handleReapply() {
      this.showDetail = false;
      this.$router.push({ path: '/zhibozhongxin', query: { showSqModal: 'true' } });
    },
    handleGoKey() {
      this.showDetail = false;
      this.$router.push('/zhibojinyao');
    }
  }
};
</script>

<style scoped lang="scss">
@import "./shenqingjilu.css";
</style>



// WEBPACK FOOTER //
// shenqingjilu.vue?7f3bf59d